import { Trans } from "@lingui/macro";
import Image from "next/image";
import { useEffect, useState } from "react";
import styled from "styled-components";
import { Button } from "~/guidelines/Button";
import { Stack } from "~/guidelines/Flex";
import { body1 } from "~/guidelines/Typography";
import Send from "../_assets/specifications/send.svg";
import TeamDesktop from "./TeamDesktop";
import TeamMobile from "./TeamMobile";

const Container = styled(Stack)`
  align-items: center;
  max-width: 1200px;
  margin: 80px auto;
  padding: 20px;
  width: 100%;
`;

const ContentWrapper = styled(Stack)`
  border: 10px solid ${({ theme }) => theme.color.text.lightFirst};
  width: 100%;
  padding: 80px;
  align-items: center;

  @media (max-width: 900px) {
    padding: 0px;
    gap: 30px;
    border: none;
  }
`;

const InvitationText = styled.p`
  ${body1}
  color: ${({ theme }) => theme.color.text.lightFirst};
  text-align: center;
  max-width: 600px;
  line-height: 1.6;
  margin: 87px auto;

  @media (max-width: 768px) {
    margin: 10px auto;
  }
`;

const FlexCenter = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`;

const Team = () => {
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 1200);
    };

    handleResize();

    window.addEventListener("resize", handleResize);

    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return (
    <Container>
      <ContentWrapper>
        {isMobile ? <TeamMobile /> : <TeamDesktop />}

        <InvitationText>
          <Trans>
            Dear investors, dear hoteliers, let&apos;s meet to reinvent the
            hotel industry in our regions together.
          </Trans>
        </InvitationText>

        <Button
          size="large"
          href="https://encore-mieux.typeform.com/to/p5ssSaDE?typeform-source=encore-mieux.com"
        >
          <FlexCenter>
            <Image src={Send} alt="send" />
            <Trans>Get in touch</Trans>
          </FlexCenter>
        </Button>
      </ContentWrapper>
    </Container>
  );
};

export default Team;
